import { getResource } from "./rest-helper";
const namespace = "tractors";
const api = { ...getResource(namespace) };
export { api as default };
